export enum EstSalesCellBlock {
  Root = 'EstSalesCell',
}
